export default "<img :src=\"gifURL\" @load=\"onGifLoad\"/>";